/* Gulab v5 — PDP helpers: short-description "read more" clamp. */
(function () {
  function initShortDesc() {
    document.querySelectorAll('.v5-short-desc').forEach(function (wrap) {
      var body = wrap.querySelector('.v5-short-desc__body');
      if (!body || wrap.dataset.v5Init) return;
      wrap.dataset.v5Init = '1';

      // Only clamp when the text actually overflows ~3 lines.
      requestAnimationFrame(function () {
        var lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 24;
        if (body.scrollHeight <= lineHeight * 3.4) return;

        wrap.classList.add('is-clamped');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'v5-short-desc__toggle';
        btn.textContent = 'Read more';
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var open = wrap.classList.toggle('is-clamped') === false;
          btn.textContent = open ? 'Read less' : 'Read more';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        wrap.appendChild(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShortDesc);
  } else {
    initShortDesc();
  }

  /* GSM size module: its own script defaults to the "model" tab. When real
     model stats are absent the tab isn't rendered — fall back to the
     "measure" tab using the module's own click handler (no JS logic edited). */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gsm').forEach(function (root) {
      if (!root.querySelector('.gsm-tab[data-gsm-tab="model"]')) {
        var measure = root.querySelector('.gsm-tab[data-gsm-tab="measure"]');
        if (measure) measure.click();
      }
    });
  });
})();
